import Api from './Api';

class _ClientApi extends Api {
    loadClients(): Promise<any> {
        return this.getHttpClient().get(`client/list`);
    }

    loadClient(id: number): Promise<any> {
        return this.getHttpClient().get(`client/detail/${id}`);
    }

    loadAllClients(): Promise<any> {
        return this.getHttpClient().get(`client/all`);
    }

    saveClient(params: any): Promise<any> {
        return this.getHttpClient().post(`client/detail`, params);
    }

    deleteClient(id: number): Promise<any> {
        return this.getHttpClient().delete(`client/${id}`);
    }

    deleteProject(project_id: number): Promise<any> {
        return this.getLocalHttpClient().delete(`projects/${project_id}`);
    }
}

export const ClientApi = new _ClientApi();
